import ArrowBack from '@mui/icons-material/ArrowBack';
import Button, { ButtonProps } from '@mui/material/Button';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const GoBackButton = (props: ButtonProps) => {
    const navigate = useNavigate();

    const handleGoBack = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    return (
        <Button startIcon={<ArrowBack />} onClick={handleGoBack} {...props}>
            Go Back
        </Button>
    );
};
